import { css, cx } from '@emotion/css';

interface PanelProps {
  title: string;
  titleExtra?: React.ReactNode;
  children?: React.ReactNode;
  contentClassName?: string;
}

export const Panel = (props: PanelProps) => {
  const { title, titleExtra, children, contentClassName } = props;

  return (
    <div className={cx('flex flex-col', contentCls)}>
      <div className="flex items-center justify-between">
        <div className="text-[var(--fett-text-primary)] font-medium">{title}</div>
        {titleExtra}
      </div>
      <div className={cx('pt-2 relative', contentClassName)}>{children}</div>
    </div>
  );
};

const contentCls = css`
  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;
